import React from 'react';
import { WebMenuOption } from '../../../../../../options';
import WebMenuItem from '../../shared/WebMenuItem';

const LinkMenuItem: React.FC<{ option: WebMenuOption }> = ({ option }) => {
  return <WebMenuItem option={option} />;
};

export default LinkMenuItem;
